<template>
    <v-card v-redirect-if-no-permission:CUSTOMER_SUPPORT>
        <loading-component :value="loading"/>
        <v-layout row wrap>
            <v-flex xs12>
                <v-layout justify-center>
                    <v-flex xs6 md3 lg2>
                        <v-card :class="{selected: choice == 'captain'}" @click="choice = 'captain'" class="clickable">
                            <v-img :src="captain_icon"/>
                            <v-divider/>
                            <v-card-title primary-title class="title" style="text-align: center;">
                                {{ $t("monitoring.ratingCauses.captainRatingCauses") }}
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs6 md3 lg2 offset-md2>
                        <v-card :class="{selected: choice == 'passenger'}" @click="choice = 'passenger'"
                                class="clickable">
                            <v-img :src="passenger_icon"/>
                            <v-divider/>
                            <v-card-title primary-title class="title" style="text-align: center;">
                                {{ $t("monitoring.ratingCauses.passengerRatingCauses") }}
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-divider/>
            </v-flex>
            <template v-if="!!choice">
                <v-flex xs12>
                    <v-layout justify-center>
                        <v-rating v-model="rating_value" x-large light color="secondary"/>
                    </v-layout>
                </v-flex>
                <v-flex md8 xs12 offset-md2>
                    <v-form ref="form">
                        <v-text-field v-model="cause" :label="$t('monitoring.ratingCauses.cause')"
                                      :rules="[val => !!val || $t('monitoring.ratingCauses.requiredField') , val => !!val && val.length >= 3 || $t('monitoring.ratingCauses.min3Chars')]"/>
                    </v-form>
                </v-flex>
                <v-flex md2 xs12>
                    <v-btn color="primary" @click="addNewCause">{{ $t("monitoring.ratingCauses.addNewCause") }}</v-btn>
                </v-flex>
                <v-flex xs12>
                    <data-table
                            ref="dataTable"
                            :url="url"
                            :initial-url-search-params="params"
                            :fields-hidden-main="['rating_value','deleted_at','updated_at']"
                            :fields-hidden-edit="['id','created_at','updated_at','rating_value','deleted_at']"
                            :titles="titles"
                            :enable-add="false"
                    />
                </v-flex>
            </template>
        </v-layout>
    </v-card>
</template>

<script>
    import captain_icon from "@/assets/captain_icon.jpg";
    import passenger_icon from "@/assets/passenger_icon.jpg";
    import DataTable from "@/components/monaco/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";


    export default {
        name: "RatingCauses",
        title() {
            return this.$t("monitoring.ratingCauses.title");
        },
        components: {LoadingComponent, DataTable},
        watch: {
            rating_value() {
                this.cause = null;
            }
        },
        data() {
            return {
                choice: null,
                rating_value: 1,
                cause: null,
                loading: false
            }
        },
        methods: {
            addNewCause() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    this.axios.post(this.url, this.$data)
                        .then(
                            ({data: {data}}) => {
                                this.cause = null;
                                this.$refs.dataTable.addItemToTable(data);
                            }
                        )
                        .finally(
                            () => {
                                this.loading = false;
                            }
                        )
                }
            }
        },
        computed: {
            titles() {
                return {}
            },
            passenger_icon() {
                return passenger_icon;
            },
            captain_icon() {
                return captain_icon;
            },
            params() {
                const params = new URLSearchParams();
                params.append('rating_value', this.rating_value);
                return params;
            },
            url() {
                if (this.choice === 'passenger')
                    return this.api.ACTIONS.PASSENGER_RATING_CAUSES;
                else
                    return this.api.ACTIONS.CAPTAIN_RATING_CAUSES;
            }
        }
    }
</script>

<style scoped>
    .clickable:hover {
        cursor: pointer;
    }

    .selected {
        border: 2px gold solid;
    }
</style>